export class CommonMethods{
    static showLog(tag: string, message: string) {
        // console.log(tag, message)
    }
}